import React, { useState, useEffect } from 'react';
import './Header2.css';
import logo from '../assets/logo.png';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Header2 = ({ solid = false }) => {  // 👈 nova prop aqui
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`header ${scrolled ? 'scrolled' : ''} ${
        solid ? 'header--solid' : ''
      }`}
    >
      {/* MENU ESQUERDA */}
      <nav className="menu-wrapper">
        <ul className="header-links">
          <li><Link to="/">INÍCIO</Link></li>
          <li><Link to="/sobre">SOBRE</Link></li>
          <li><Link to="/servicos">SERVIÇOS</Link></li>
          <li>
            <a
              href="https://www.retrovibezbodywear.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LOJA
            </a>
          </li>
        </ul>
      </nav>

      {/* ÍCONES DIREITA */}
      <div className="header-icons-right">
        <a
          href="https://www.instagram.com/retro_flex.gym"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="icon" />
        </a>
        <a
          href="https://wa.me/5511919392331"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp className="icon" />
        </a>
      </div>

      {/* LOGO CENTRO */}
      <div className="logo-container">
        <img
          src={logo}
          alt="Logo Retroflex"
          className={`logo ${scrolled ? 'small-logo' : ''}`}
        />
      </div>
    </header>
  );
};

export default Header2;
